/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from "react";
import {
    EuiFlexGroup,
    EuiFlexItem,
    EuiFieldText,
    EuiFieldNumber,
    EuiSwitch,
    EuiFormRow,
} from "@elastic/eui";
import { FormattedMessage } from "react-intl";

const ExpensesFields = ({
    label,
    showPrice = false,
    showTotal = false,
    showNotes = false,
    showCount = false,
    append,
    onTotalChange,
    expenseValue,
    id,
    onSwitchChange,
    isSwitchOn,
    setIsSaved,
    isTotalDeducted,
}) => {
    // const [isSwitchOn, setIsSwitchOn] = useState(false);
    const [price, setPrice] = useState();
    const [quantity, setQuantity] = useState();
    const [notes, setNotes] = useState("");
    const [total, setTotal] = useState();

    const calculateTotal = (fieldPrice, fieldQuantity) => Math.max(0, fieldPrice * fieldQuantity);

    const handleSwitchChange = (e) => {
        const isChecked = e.target.checked;
        onSwitchChange(id, isChecked);

        setIsSaved(false);
        if (!isChecked) {
            // Reset values when switch is off
            const resetTotal = 0;
            onTotalChange(id, { price: 0, quantity: 0, notes: "", total: resetTotal });
        } else {
            onTotalChange(id, { price, quantity, notes, total });
        }
    };

    useEffect(() => {
        const hasExpenseValue =
            expenseValue?.price > 0 || expenseValue?.quantity > 0 || expenseValue?.total > 0;

        if (expenseValue) {
            setPrice(expenseValue?.price);
            setQuantity(expenseValue?.quantity);
            setNotes(expenseValue?.notes);
            setTotal(expenseValue?.total);
            onSwitchChange(id, hasExpenseValue);
            onTotalChange(id, {
                price: expenseValue?.price,
                quantity: expenseValue?.quantity,
                notes: expenseValue?.notes,
                total: expenseValue?.total,
            });
        }
    }, [expenseValue, id]);
    const handlePriceChange = (e) => {
        const newPrice = Math.max(0, parseFloat(e.target.value) || 0);
        const updatedTotal = calculateTotal(newPrice, quantity);
        setPrice(newPrice);
        setTotal(updatedTotal);
        onTotalChange(id, { price: newPrice, quantity, notes, total: updatedTotal });
        setIsSaved(false);
    };

    const handleQuantityChange = (e) => {
        const newQuantity = Math.max(0, parseFloat(e.target.value) || 0);
        const updatedTotal = calculateTotal(price, newQuantity);
        setQuantity(newQuantity);
        setTotal(updatedTotal);
        onTotalChange(id, { price, quantity: newQuantity, notes, total: updatedTotal });
        setIsSaved(false);
    };

    const handleNotesChange = (e) => {
        const newNotes = e.target.value;
        setNotes(newNotes);
        onTotalChange(id, { price, quantity, notes: newNotes, total });
        setIsSaved(false);
    };

    return (
        <EuiFlexGroup
            alignItems="center"
            gutterSize="m"
            style={{ width: "100%" }}
        >
            {/* Switch */}
            <EuiFlexItem grow={1}>
                <EuiSwitch
                    label={label}
                    checked={isSwitchOn}
                    onChange={handleSwitchChange}
                    style={{ paddingInline: "10px" }}
                />
            </EuiFlexItem>

            {showCount && (
                <EuiFlexItem grow={1}>
                    <EuiFormRow label={<FormattedMessage id="count" />}>
                        <EuiFieldNumber
                            append={<span style={{ padding: "10px" }}>{append}</span>}
                            disabled={!isSwitchOn}
                            value={quantity}
                            min={0}
                            onChange={handleQuantityChange}
                        />
                    </EuiFormRow>
                </EuiFlexItem>
            )}

            {/* Price Field (if needed) */}
            {showPrice && (
                <EuiFlexItem grow={1}>
                    <EuiFormRow label={<FormattedMessage id="price" />}>
                        <EuiFieldNumber
                            append={
                                <span style={{ padding: "10px" }}>
                                    <FormattedMessage id="egp" />
                                </span>
                            }
                            value={price}
                            onChange={handlePriceChange}
                            min={0}
                            step="0.5"
                            disabled={!isSwitchOn}
                        />
                    </EuiFormRow>
                </EuiFlexItem>
            )}

            {/* Total Field (if needed) */}
            {showTotal && (
                <EuiFlexItem grow={1}>
                    <EuiFormRow label={<FormattedMessage id="total" />}>
                        <EuiFieldNumber
                            value={total}
                            step="0.5"
                            readOnly
                            min={0}
                            disabled={!isSwitchOn}
                            style={{
                                border: isTotalDeducted ? "1px solid red" : "1px solid #53e795",
                            }}
                        />
                    </EuiFormRow>
                </EuiFlexItem>
            )}

            {/* Notes Field (if needed) */}
            {showNotes && (
                <EuiFlexItem grow={3}>
                    <EuiFormRow label={<FormattedMessage id="notes" />}>
                        <EuiFieldText
                            value={notes}
                            onChange={handleNotesChange}
                            disabled={!isSwitchOn}
                        />
                    </EuiFormRow>
                </EuiFlexItem>
            )}
        </EuiFlexGroup>
    );
};

export default ExpensesFields;
